import { AccountGroup } from '@amzn/aac-chrome-internal-api';
import * as React from 'react';

type UseAccountDropdownSearchProps = {
  accounts: AccountGroup[];
};

export type UseAccountDropdownSearchResponse = {
  onSearch: any;
  accountTypeList: AccountGroup[];
  onClear: () => void;
  searchValue: string;
};

export const useAccountDropdownSearch = ({
  accounts,
}: UseAccountDropdownSearchProps): UseAccountDropdownSearchResponse => {
  const [accountTypeList, setAccountTypeList] = React.useState<AccountGroup[]>(
    accounts || [],
  );
  const searchWord = React.useRef<string>('');

  const searchAccounts = (newAccountTypeList: AccountGroup[]) => {
    const regex = new RegExp(searchWord.current, 'i'); // ignore case
    return newAccountTypeList.map((accountType) => {
      return {
        ...accountType,
        accounts: accountType.accounts.filter((account) => {
          // combine list of values for search
          const combinedString = [
            account.label,
            account.entityId,
            account.marketplaceName,
          ].join('|');
          return regex.test(combinedString);
        }),
      };
    });
  };

  const handleSearch = () => {
    let newAccountTypeList = [...accounts];

    if (searchWord.current) {
      newAccountTypeList = searchAccounts(accounts);
    }

    newAccountTypeList = newAccountTypeList.filter(
      (accountTypeList) => accountTypeList.accounts.length > 0,
    );

    setAccountTypeList(newAccountTypeList);
  };

  const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    searchWord.current = e.target.value;
    handleSearch();
  };

  const onClear = () => {
    searchWord.current = '';
    handleSearch();
  };

  return {
    onSearch,
    accountTypeList,
    onClear,
    searchValue: searchWord.current,
  };
};
